
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M9.6 3.265a1 1 0 01.567.902v11.666a1 1 0 01-1.625.781L4.649 13.5H1.667a1 1 0 01-1-1v-5a1 1 0 011-1h2.982l3.893-3.114a1 1 0 011.058-.12zM8.167 6.247L5.625 8.281A1 1 0 015 8.5H2.667v3H5a1 1 0 01.625.22l2.542 2.033V6.247zM15.185 3.401a1 1 0 011.414 0 9.333 9.333 0 010 13.198 1 1 0 01-1.415-1.414 7.333 7.333 0 000-10.37 1 1 0 010-1.414zm-2.942 2.942a1 1 0 011.414 0 5.167 5.167 0 010 7.306 1 1 0 01-1.414-1.414 3.167 3.167 0 000-4.478 1 1 0 010-1.414z"}})])
          )
        }
      }
    